
export class StylesDto {
  styleId?: number;
  style?: string;
  styleName?: string;
  msc?: string;
  season?: string;
  YEAR?: number;
  kimbleSize?: string;
  styleType?:string;
  isFleece?:string;
  createdUser?: string;
  isActive?: boolean;
  versionFlag?: number;
  updatedAt?: string;
  updatedUser?: string;


  constructor( styleId?: number,style?: string,styleName?: string,msc?: string,season?: string,YEAR?: number,kimbleSize?: string,styleType?:string,isFleece?:string,createdUser?: string,isActive?: boolean,versionFlag?: number,updatedAt?: string,updatedUser?: string, ) {
    this.styleId = styleId;
    this.style = style; 
    this.styleName = styleName;
    this.msc = msc;
    this.season = season;
    this.YEAR = YEAR;
    this.kimbleSize = kimbleSize;
    this.styleType =  styleType
    this.isFleece = isFleece
    this.createdUser = createdUser;
    this.isActive = isActive;
    this.versionFlag = versionFlag;
    this.updatedAt = updatedAt;
    this.updatedUser = updatedUser;

  }
}
